// extracted by mini-css-extract-plugin
export var box = "_5e-0";
export var check = "_5e-1";
export var checkboxButton = "_5e-6";
export var checkboxGroup = "_5e-5";
export var disabled = "_5e-7";
export var ghost = "_5e-9";
export var input = "_5e-2";
export var label = "_5e-4";
export var normal = "_5e-8";
export var uncheck = "_5e-3";